import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HeroIndustrialExcellence from "./sections/HeroIndustrialExcellence";
import VoicesOfRejuvenation from "./sections/VoicesOfRejuvenation";
import PracticeManagementReimagined from "./sections/PracticeManagementReimagined";
import TheJourneyToMagic from "./sections/TheJourneyToMagic";
import ReadyForTaxSeason from "./sections/ReadyForTaxSeason";
import AcademyBenefits from "./sections/AcademyBenefits";
import ContactCTA from "./sections/ContactCTA";
import Footer from "@/reusable_sections/Footer";
import AboutAcademy from "./sections/AboutAcademy";
import ClassesLevelsGrid from "./sections/ClassesLevelsGrid";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <HeroIndustrialExcellence />
      <AboutAcademy />
      <ClassesLevelsGrid />
      <VoicesOfRejuvenation />
      <PracticeManagementReimagined />
      <TheJourneyToMagic />
      <ReadyForTaxSeason />
      <AcademyBenefits />
      <ContactCTA />
      <Footer />
    </div>;
}